import React from 'react';
import { MarketplaceTax } from '@spike/marketplace-model';
import {
    GenericOrderItem,
    isAddOnServiceOrderItem,
    isCustomOrderItem,
    isProductOrderItem
} from 'components/Payments/SingleSale/SingleSale';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { SingleSaleTableItemTaxesSelector } from 'components/Payments/SingleSale/Table/Item/Taxes/Selector/SingleSaleTableItemTaxesSelector';

type ItemTaxesProps = {
    item: GenericOrderItem;
    inputClassName?: string;
    onChange: (tax?: MarketplaceTax) => void;
};

export const SingleSaleTableItemTaxes: React.FunctionComponent<ItemTaxesProps> = props => {
    const marketplaceTaxes = useSelector<RootState, Array<MarketplaceTax>>(
        state => state.marketplace.marketplace.taxes
    );

    // const taxLabel = React.useMemo(() => {
    //     let taxesName = '';

    //     if (isProductOrderItem(props.item)) {
    //         taxesName =
    //             props.item.product.businessProduct?.pricing.taxes
    //                 ?.map(tax => `${tax.name} (${tax.percentage}%)`)
    //                 .join(' - ') || '';
    //     }

    //     if (isAddOnServiceOrderItem(props.item)) {
    //         taxesName = props.item.addOnService.taxes?.map(tax => `${tax.name} (${tax.percentage}%)`).join(' - ') || '';
    //     }

    //     if (props.item.orderItem.taxId) {
    //         taxesName = marketplaceTaxes.find(tax => tax.id === props.item.orderItem.taxId)?.name || '';
    //     }

    //     return taxesName.length > 0 ? taxesName : '-';
    // }, [props.item]);

    const isReadOnly = React.useMemo(() => {
        if (isCustomOrderItem(props.item)) {
            return false;
        }

        return true;
    }, [props.item]);

    const taxOptions = React.useMemo(() => {
        if (isProductOrderItem(props.item)) {
            return props.item.product.businessProduct?.pricing.taxes || [];
        }

        if (isAddOnServiceOrderItem(props.item)) {
            return props.item.addOnService.taxes || [];
        }

        return [];
    }, [props.item]);

    const selectedTaxIds = React.useMemo(() => {
        if (isCustomOrderItem(props.item) && props.item.orderItem.taxId) {
            return [Number(props.item.orderItem.taxId)];
        }

        if (isProductOrderItem(props.item)) {
            return props.item.product.businessProduct?.pricing.taxes?.map(tax => Number(tax.id)) || [];
        }

        if (isAddOnServiceOrderItem(props.item)) {
            return props.item.addOnService.taxes?.map(tax => Number(tax.id)) || [];
        }

        return [];
    }, [props.item]);

    const changeTaxHandler = (tax: MarketplaceTax | undefined) => {
        if (!isCustomOrderItem(props.item)) {
            return false;
        }

        props.onChange(tax);
    };

    return (
        <SingleSaleTableItemTaxesSelector
            readOnly={isReadOnly}
            options={taxOptions}
            selectedTaxIds={selectedTaxIds}
            onSelect={changeTaxHandler}
        />
    );
};
